"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _Icon = _interopRequireDefault(require("../../../../Icon")),
    _viewTypes = require("../../../constants/viewTypes");

function ListViewSelector(a) {
  var b = a.onChangeView,
      c = a.view,
      d = a.bothViewsAvailable,
      e = a.isMobile;
  if (!d) return null;
  var f = e ? 25 : 20;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Icon["default"], {
    key: "grid-icon",
    name: "grid",
    onClick: b(_viewTypes.GRID_VIEW),
    color: c === _viewTypes.GRID_VIEW ? "black" : "michael",
    size: f
  }), _react["default"].createElement(_Icon["default"], {
    key: "list-icon",
    name: "list",
    onClick: b(_viewTypes.LIST_VIEW),
    size: f,
    color: c === _viewTypes.LIST_VIEW ? "black" : "michael"
  }));
}

var _default = (0, _react.memo)(ListViewSelector);

exports["default"] = _default;